import React from "react";
import { connect } from "react-redux";
import OrdersList from "../OrdersList";
import { fetchOrders } from "../../actions/support";
import withSupportOrderFilters from "./withSupportOrderFilters";

const mapStateToProps = ({ support }) => ({ orders: support.orders });

const SupportOrdersList = withSupportOrderFilters(props => (
  <OrdersList {...props} detailsUri="/dashboard/verification" />
));

const mapDispatchToProps = { fetchOrders };

export default connect(mapStateToProps, mapDispatchToProps)(SupportOrdersList);
